import { FilterOption, PlpHierarchyFilterItemProps } from '../PlpFilters.type';
import { FilterName } from 'src/plp/components/FilterName/FilterName';
import { IconSeat } from 'src/general/Icons/IconSeat';
import { FilterOptionFieldsGroup } from '../components/Fields/FilterOptionFieldsGroup';
import { FilterAccordion } from '../components/FilterAccordion/FilterAccordion';

type Props = PlpHierarchyFilterItemProps<FilterOption>;

export const FilterSeats = ({ options, currentFilters, index, showNotificationBadge, ...props }: Props) => {
  const id = 'seats';
  const header = <FilterName icon={<IconSeat />} label="Seats" showNotificationBadge={showNotificationBadge} />;
  const content = (
    <FilterOptionFieldsGroup
      options={options.map((option) => ({ ...option, label: option.label ?? '' }))}
      currentFilters={currentFilters}
      {...props}
    />
  );

  return <FilterAccordion id={id} header={header} content={content} index={index} />;
};
